export type InventurEinheit = string;

export type Grundeinheit = 'Stück' | 'Kilogramm';

/** Short unit labels shown inside the narrow Ist input field. */
export const EINHEIT_KUERZEL: Readonly<Record<string, string>> = {
  Stück: 'STK',
  STÜCK: 'STK',
  Karton: 'KAR',
  KARTON: 'KAR',
  Kiste: 'KIS',
  KISTE: 'KIS',
  Beutel: 'BEU',
  BEUTEL: 'BEU',
  Kilogramm: 'KG',
  KILOGRAMM: 'KG',
  KG: 'KG',
};
